import { ref } from 'vue';
import { getBrands, getModels, getVehicleTypes } from '@/services/api';
import type { CarBrand, CarModel } from '@/types/quote.types';

export const useVehicleData = () => {
  const brands = ref<CarBrand[]>([]);
  const tipos = ref<Array<{ id: string; label: string }>>([]);
  const models = ref<CarModel[]>([]);
  const isLoadingBrands = ref(false);
  const isLoadingTypes = ref(false);
  const isLoadingModels = ref(false);

  const loadBrands = async (year: number): Promise<void> => {
    isLoadingBrands.value = true;
    
    try {
      const brandsData = await getBrands(year);
      brands.value = brandsData.map(b => ({ id: String(b.id), name: b.name }));
    } catch (error) {
      console.error('❌ Error cargando marcas:', error);
      brands.value = [];
    } finally {
      isLoadingBrands.value = false;
    }
  };

  const loadTypes = async (year: number, brandId: string): Promise<void> => {
    if (!year) {
      console.error('No hay año seleccionado para cargar tipos');
      tipos.value = [];
      return;
    }

    isLoadingTypes.value = true;
    
    try {
      const typesData = await getVehicleTypes(year, brandId);
      tipos.value = typesData.map(t => ({ id: t.id, label: t.name }));
    } catch (error) {
      console.error('Error cargando tipos:', error);
      tipos.value = [];
    } finally {
      isLoadingTypes.value = false;
    }
  };

  const loadModels = async (year: number, brandId: string, typeId?: string): Promise<void> => {
    if (!year) {
      console.error('No hay año seleccionado para cargar modelos');
      models.value = [];
      return;
    }

    isLoadingModels.value = true;
    
    try {
      const modelsData = await getModels(year, brandId, typeId || null);
      models.value = modelsData.map(m => ({ 
        id: String(m.id), 
        name: m.name,
        brandId: m.brandId 
      }));
    } catch (error) {
      console.error('Error cargando modelos:', error);
      models.value = [];
    } finally {
      isLoadingModels.value = false;
    }
  };

  const resetBrands = () => {
    brands.value = [];
  };

  const resetTypes = () => {
    tipos.value = [];
  };

  const resetModels = () => {
    models.value = [];
  };

  const resetAll = () => {
    resetBrands();
    resetTypes();
    resetModels();
  };

  return {
    brands,
    tipos,
    models,
    isLoadingBrands,
    isLoadingTypes,
    isLoadingModels,
    loadBrands,
    loadTypes,
    loadModels,
    resetBrands,
    resetTypes,
    resetModels,
    resetAll,
  };
};

